import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { DrugATC } from "../../../Data/Art57Data/DrugATC";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeDrugATC extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new DrugATC(new FieldDefinition(injector)),
        'ATC Code'
      );
      this.parent = parent;  
      this.labelNodeName = 'Drug ATC';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(lazy:boolean=true): void {
      if (this.data && this.data.model &&
        this.data.model.atccode &&
        this.data.model.atccode.value) {
            this.label = this.data.model.atccode.value;                
        } else {
          this.label = this.labelTemplate;
        } 

    }
  
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.atccode && this.data.model.atccode.value
          ? this.data.model.atccode.value
          : 'Not selected',
        this.data.model && this.data.model.atccode && this.data.model.atccode.name 
          ? this.data.model.atccode.name
          : 'ATC Code',
      ];
    }
   
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeDrugATC = new TreeNodeDrugATC(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {

      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];
      
      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
   }
  